import {
  Box,
  BoxProps,
  Grid,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { HTMLProps } from "react";

export const CardGrid = styled(Grid)(({ theme }) => ({
  display:"flex",
  gap:theme.spacing(3),
  width:"calc(100% - 50px)",

  [`${theme.breakpoints.down("sm")}`]:{
    flexDirection: "column-reverse",
    width:"100%"
  }
}));

export const CardBodyGrid = styled(Grid)(({ theme }) => ({
  alignItems: "flex-start",
  display:"flex",
  flexDirection: "column",
  justifyContent: "space-between",

  gap:"16px",
  minHeight:"172px",
  padding:"0",
  width:"calc(100% - 290px)",

  [`${theme.breakpoints.down("sm")}`]:{
    minHeight:"unset",
    padding: "0",
    width:"100%"
  }
}));

export const DescriptionTypography = styled(Typography)(({ theme }) => ({
  width: "100%",
  marginTop: "auto",
  fontSize:"1.25rem",
  lineHeight:"1.5rem",
  color: theme.customColors.textWidget,
  overflowWrap: "anywhere",

  [`${theme.breakpoints.down("sm")}`]:{
    fontSize: "16px"
  },

  "-webkit-box-orient": "vertical",
  "-webkit-line-clamp": "3",
  display: "-webkit-box",
  overflow: "hidden",
  textOverflow: "ellipsis"
}));

export const ImageBox = styled(Box)<
  BoxProps & HTMLProps<HTMLImageElement>
>(() => ({
  borderRadius:"8px",
  boxShadow:"box-shadow: 16px 16px 22px rgba(0, 0, 0, 0.4);",
  objectFit: "cover",
  padding:0,
  paddingBlock: " 0 !important",

  height:"100%",
  width: "100%"
}));

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontSize: "2rem",
  fontWeight: 700,
  lineHeight: 1.3125,
  color: theme.customColors.textWidget,
  width: "100%",
  overflowWrap: "anywhere",

  [`${theme.breakpoints.down("sm")}`]:{
    fontSize: "24px"
  }
}));


